import Const from 'constants';
import Action from 'actions';

function checkPlayer(checkedPlayers, playerId, lineupRoles) {
    checkedPlayers[playerId] = checkedPlayers[playerId] || {};

    lineupRoles.map((lineupRole) => (checkedPlayers[playerId][lineupRole] = true));

    return checkedPlayers;
}

function uncheckPlayer(checkedPlayers, playerId, lineupRoles) {
    checkedPlayers[playerId] = checkedPlayers[playerId] || {};

    lineupRoles.map((lineupRole) => delete checkedPlayers[playerId][lineupRole]);

    if (isEmpty(checkedPlayers[playerId])) {
        delete checkedPlayers[playerId];
    }

    return checkedPlayers;
}

const FilterLineupsByPlayer = {
    filterLineupsByCheckedPlayer(checkedPlayer) {
        return (dispatch, getState) => {
            const {playerId, lineupRoles = [Const.OVERALL_MODE], isChecked} = checkedPlayer;
            const {filterLineupsByPlayer} = getState();

            let {checkedPlayers} = filterLineupsByPlayer;

            if (Boolean(isChecked)) {
                checkedPlayers = checkPlayer(checkedPlayers, playerId, lineupRoles);
            } else {
                checkedPlayers = uncheckPlayer(checkedPlayers, playerId, lineupRoles);
            }

            dispatch(this.setLineupsFilterByCheckedPlayers(checkedPlayers));
        };
    },

    removePlayerFromLineupsFilterByCheckedPlayer(playerId) {
        return (dispatch, getState) => {
            const {filterLineupsByPlayer} = getState();

            let {checkedPlayers} = filterLineupsByPlayer;

            delete checkedPlayers[playerId];

            dispatch(this.setLineupsFilterByCheckedPlayers(checkedPlayers));
        };
    },

    setLineupsFilterByCheckedPlayers(checkedPlayers) {
        return (dispatch, getState) => {
            const {lineupPlayerMap} = getState();

            const lineupIds = lineupPlayerMap.getLineupIdsByCheckedPlayers(checkedPlayers);
            const playerIds = lineupPlayerMap.getPlayerIdsByLineupIds(lineupIds);

            // #DFSA-149 if there are checked players but none lineups are found where they are present together,
            // to avoid having the list of used players empty we add checked players as used.
            const usedPlayerIds = arrayUnique([...playerIds, ...Object.keys(checkedPlayers).map(String)]);

            dispatch({
                type: Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER,
                data: {
                    checkedPlayers,
                    lineupIds,
                    usedPlayerIds,
                },
            });

            dispatch(Action.set('LineupsUsedPlayers', {lineupIdsOnly: lineupIds}));
        };
    },
};

export default FilterLineupsByPlayer;
